import AmericanSeniorLogoSrc from "../assets/images/american_senior_logo.png";
import GuildLogoSrc from "../assets/images/guild_logo.png";
import NAFLogoSrc from "../assets/images/naf_reverse_logo.png";

export const LENDERS = [
  {
    apiName: "Guild",
    displayName: "Guild Mortgage",
    url: null,
    adCopy: "Next Step: We need to speak with you! Please call (855)-517-0091",
    logoSrc: GuildLogoSrc,
    nmls: "NMLS ID 3274",
  },
  {
    apiName: "New American Funding",
    displayName: "New American Funding (NAF)",
    url: null,
    adCopy: (
      <>
        We appreciate the opportunity to assist you. A licensed Loan Officer from New American Funding (NAF) will be reaching out shortly to discuss your goals and answer any questions you may have about the program.
        <br /><br />
        In the meantime, if you have additional questions, please feel free to email us at{" "}
        <a href="mailto:reverse@nafinc.com">reverse@nafinc.com</a>, and we'll be happy to help.
        <br /><br />
        Thank you again for connecting with us. We look forward to speaking with you soon!
      </>
    ),
    logoSrc: NAFLogoSrc,
    nmls: "NMLS ID #6606",
    layout: { logoPosition: "above", align: "left" },
  },
  {
    // HighTechLending Inc, doing business as American Senior Lending
    // (boberdoo partner 231). HTL asked (2026-08-31) to be called out on the
    // thank-you page when they buy the lead; approved 2026-09-08. The logo
    // and the Trustpilot / Google review links were supplied by HTL's CMO
    // (Pete Bishop, 2026-09-08). The links are plain links on purpose: a
    // hard-coded star rating or review count would go stale and become a
    // consumer-facing claim nobody keeps current. No phone number: HTL's
    // intake line is reached through RateZip's own tracking number, not
    // printed here. apiName must equal the company_name boberdoo reports
    // for the partner (the lead_buyer value on their sold leads); any other
    // string falls back to the neutral forwarded page, never to a guessed
    // name.
    apiName: "HighTechLending-reverse",
    displayName: "American Senior Lending",
    url: null,
    adCopy: (
      <>
        <span>You've been matched with American Senior Lending!</span>
        <br /><br />
        See what their customers say on{" "}
        <a href="https://www.trustpilot.com/review/americansenior.com" target="_blank" rel="noreferrer">Trustpilot</a>
        {" "}and{" "}
        <a href="https://www.google.com/search?q=american+senior+lending" target="_blank" rel="noreferrer">Google</a>.
      </>
    ),
    logoSrc: AmericanSeniorLogoSrc,
    nmls: "HighTechLending Inc, doing business as American Senior Lending is an Equal Housing Lender, NMLS ID #7147",
  },
];

export function getLenderByBuyer(buyerName) {
  if (!buyerName) return null;
  // Buyers without approved co-branded copy must not be named on the result
  // page (buyer compliance requirement); Result then shows the neutral
  // "forwarded to a participating lender" default.
  return LENDERS.find((l) => l.apiName === buyerName) || null;
}
